module.exports = __webpack_public_path__ + "img/sales.0f13e843.svg";